<!-- 
Listagem do cadastr de regras ST
-->

<script>
import BarList from '../components/bar-list'
import BarGrid from '../components/bar-grid'
import RegrafcpForm from './regrafcp-form'
import { getText, formatDate, formatValue } from '../shared/utils'
import { SysVars } from '../main';

export default {
    data () {
        return {
            showForm: false, //exibe a tela de manutencao
            codregrafcp: 0,
            empty: false,
        }
    },

    computed: {
        metadata: function () {
            return this.$store.getters.getEntities.metadata
        },
        regraList: function () {
            return this.$store.getters.getRegrafcpList
        }
    },

    methods: {
        handleEdit (codregrafcp) {
            //abre a tela de edicao
            this.crud = SysVars.crudU
            this.codregrafcp = codregrafcp
            this.showForm = true
        },

        handleIncluir () {
            //abre a tela de edicao
            this.crud = SysVars.crudI
            this.codregrafcp = 0
            this.showForm = true;
        },

        closeForm () {
            this.showForm = false
            this.loadData()
        },

        search (value) {
            //efetua a pesquisa
            this.filter = '{"ncm":{"$like":"' + value + '%25"}}'
            this.loadData()
        },

        async loadData () {
            await this.$store.dispatch('loadRegrafcpList', { filter: this.filter } )
            if (this.regraList.length == 0) {
                this.empty = true
            } else {this.empty = false}
        },
        textFinalidade (value) {
            if (this.metadata) {
              var item = this.metadata.regrafcp.finalidade.options.filter(x => x.id === value);
              if (item.length) { return item[0].text }
            } else { return value }
        },
    },

    components: {
        BarList, BarGrid, RegrafcpForm
    },

    filters: {
        format: function (value) {
            return formatValue(value, 2)
        },

    },

    mounted() {
    },

    beforeDestroy() {
    },

    created () {
        this.showForm = false
        this.loadData()
    }
}

</script>

<template>
    <div id="grid">
        <div id="list" v-show="!showForm"> 

            <bar-list
                :refresh-button="true" 
                :new-button="true" 
                single-entity="Alíquota FCP" 
                plural-entity="Alíquotas FCP"
                v-on:search="search"
                v-on:new="handleIncluir"
                v-on:refresh="loadData()"
                title-search="Pesquise pelo ncm">
            </bar-list>
            <br>
            <div class="default-container nb-card-list">
                <alert v-if="empty" type="warning" text="Nenhuma regra foi encontrada."></alert>

                <article class="nb-card" v-for="(regra, index) in regraList" :key="regra.codregrafcp || index">
                    <div class="nb-card-top">
                        <div class="nb-card-identity">
                            <div class="nb-card-unit">
                                {{ regra.uf }}
                            </div>
                            <div class="nb-card-title">
                                <div class="nb-card-title-line">
                                    <h2>{{ regra.descricao || ('NCM ' + regra.ncm) }}</h2>
                                </div>
                                <div class="nb-card-code">
                                    NCM <strong>{{ regra.ncm }}</strong>
                                    <span class="ml-2">UF <strong>{{ regra.uf }}</strong></span>
                                </div>
                            </div>
                        </div>

                        <div class="nb-card-actions">
                            <bar-grid 
                                :options="{barDefault: true, btnView: false, btnEdit: true, btnEditLabel: 'Editar'}" 
                                :moreActions="[]" 
                                v-on:edit="handleEdit(regra.codregrafcp)">
                            </bar-grid>
                        </div>
                    </div>

                    <div class="nb-card-details">
                        <div class="nb-card-detail" v-if="metadata && metadata.regrafcp && metadata.regrafcp.afcp">
                            <span class="nb-card-detail-label">{{ metadata.regrafcp.afcp.label }}</span>
                            <strong>{{ regra.afcp }}%</strong>
                        </div>
                        <div class="nb-card-detail" v-if="metadata && metadata.regrafcp && metadata.regrafcp.afcpst">
                            <span class="nb-card-detail-label">{{ metadata.regrafcp.afcpst.label }}</span>
                            <strong>{{ regra.afcpst }}%</strong>
                        </div>
                    </div>
                </article>
            </div>

        </div>

        <regrafcp-form v-if="showForm" :crud="crud" :index="codregrafcp" v-on:closeform="closeForm"></regrafcp-form>

    </div>
</template>

<style scoped>
.default-container.nb-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0;
  background: transparent;
  border: 0;
  box-shadow: none;
}

.nb-card {
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.nb-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
}

.nb-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.nb-card-identity {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  gap: 12px;
}

.nb-card-unit {
  display: flex;
  flex: 0 0 48px;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  color: #004e94;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 700;
  text-transform: uppercase;
}

.nb-card-title {
  flex: 1;
  min-width: 0;
}

.nb-card-title-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 9px;
}

.nb-card-title-line h2 {
  min-width: 0;
  margin: 0;
  color: #0b1c30;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.nb-card-code {
  margin-top: 3px;
  color: #64748b;
  font-size: 12px;
}

.nb-card-code strong {
  color: #334155;
  font-weight: 600;
}

.nb-card-actions {
  flex: 0 0 auto;
}

.nb-card-details {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 12px;
  margin: 12px 0 0 60px;
  padding-top: 11px;
  border-top: 1px solid #f1f5f9;
}

.nb-card-detail {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.nb-card-detail-label {
  color: #64748b;
  font-size: 11px;
}

.nb-card-detail > strong {
  color: #334155;
  font-size: 12px;
  font-weight: 600;
  overflow-wrap: anywhere;
}

@media (max-width: 767.98px) {
  .nb-card-top {
    align-items: flex-start;
    flex-direction: column;
  }

  .nb-card-actions {
    align-self: flex-end;
  }

  .nb-card-details {
    margin-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/forms/regrafcp-list.vue